import { CLIENT_ERROR_MESSAGES } from '../errors/errorMessages';

const NIP_REGEX = /^\d{3}-\d{3}-\d{2}-\d{2}$/; // XXX-XXX-XX-XX
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateName = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  if (value.trim().length > 200) {
    return 'Imię i nazwisko nie może przekraczać 200 znaków.';
  }
  return '';
};

export const validateEmail = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  if (!EMAIL_REGEX.test(value.trim())) {
    return 'Nieprawidłowy adres e-mail.';
  }
  return '';
};

export const validatePhone = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  if (!/^\d{9}$/.test(value.trim())) {
    return 'Niepoprawny numer telefonu';
  }
  return '';
};

export const validateAddress = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateCity = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateState = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateNip = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  if (!NIP_REGEX.test(value.trim())) {
    return CLIENT_ERROR_MESSAGES.NIP_INVALID;
  }
  return '';
};

export const validateBillingCompanyName = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateBillingNip = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  if (!NIP_REGEX.test(value.trim())) {
    return CLIENT_ERROR_MESSAGES.NIP_INVALID;
  }
  return '';
};

export const validateBillingRegon = (value: string): string => {
  if (!value.trim()) {
    return '';
  }
  const len = value.trim().length;
  if (len < 9 || len > 14) {
    return CLIENT_ERROR_MESSAGES.REGON_INVALID;
  }
  return '';
};

export const validateBillingKrs = (value: string): string => {
  if (!value.trim()) {
    return '';
  }
  const len = value.trim().length;
  if (len !== 10) {
    return CLIENT_ERROR_MESSAGES.KRS_INVALID;
  }
  return '';
};

export const validateInvoiceAddressLine1 = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateInvoiceZipCode = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  return validateZip(value);
};

export const validateInvoiceCity = (value: string): string => {
  if (!value.trim()) {
    return CLIENT_ERROR_MESSAGES.REQUIRED;
  }
  return '';
};

export const validateZip = (value: string): string => {
  if (!value) {
    return '';
  }
  if (!/^\d{2}-\d{3}$/.test(value.trim())) {
    return CLIENT_ERROR_MESSAGES.ZIP_INVALID_FORMAT;
  }
  return '';
};
